import React from 'react'
import { Provider } from '../login/Context'
import { BasicAuthLayout } from '../login/BasicAuthLayout'
import { AccountRegisterContainer } from '../../../components/AccountRegisterContainer'

export const Page = () => {
  return (
    <Provider>
      <AccountRegisterContainer>
        <BasicAuthLayout initialAlertMessage="Invalid username or password." alertType="danger" />
      </AccountRegisterContainer>
    </Provider>
  )
}
